<template>
  <div class="btn-container">
    <button type="button" :class="['btn','btn-nav', {'active': mapVehicles}]" @click="changeMapType('vehicles')">Total Vehicles</button>
    <button type="button" :class="['btn', 'btn-nav', {'active': mapDistance}]" @click="changeMapType('miles')">Miles Driven</button>
  </div>
</template>

<script>
import { computed } from 'vue';
import { useStore } from 'vuex';

export default {
  name: 'FilterButtons',
  setup() {
    const store = useStore();

    const changeMapType = (type) => {
      store.commit('setDataType', type);
    };
    return {
      mapDistance: computed(() => store.getters.isMapTypeDistance),
      mapVehicles: computed(() => store.getters.isMapTypeVehicles),
      changeMapType,
    };
  },
};
</script>
